import { administrationRouteApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import AdministrationRouteModal from "./AdministrationRouteModal";

const AdministrationRouteList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={administrationRouteApi}
    label="Administration route"
    entityLabel="administration route"
    addLabel="Add Route"
    tag="immunization-administration-route"
    headers={["Name", "Code", "Description", "Coded As", "Status", "Action"]}
    keys={["name", "code", "description", "codeMappings", "statusChip", "action"]}
    displayName={(item) => item.display}
    mapRow={(item) => ({
      codeMappings:
        (item.externalCodes || [])
          .map((entry) => `${entry.system}:${entry.code}`)
          .join(", ") || "—",
    })}
    Modal={AdministrationRouteModal}
    searchText={searchText}
  />
);

export default AdministrationRouteList;
